import {AnimatePresence, motion} from "framer-motion";
import {Typography} from "@/shared/ui/typography";
import cn from "classnames";
import Image from "next/image";
import {optionsBuilder} from "@/modules/services/constants";

export interface OtherBlocksProps {
  index: number;
  currentOpened: number[];
  option: ReturnType<typeof optionsBuilder>[0];
  isDesktop: boolean;
  isLaptop: boolean;
}

const OtherBlocks = (props: OtherBlocksProps) => {
  const { currentOpened, index, option, isDesktop, isLaptop } = props;

  return (
    <AnimatePresence>
      {currentOpened.includes(index) && (
        <div className="mb:flex mb:max-tb:flex-col dk:gap-[128px] tb:gap-[58px] mb:gap-[23px]">
          <div className="overflowX-hidden relative">
            <motion.div
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: {
                  opacity: 1,
                  height: 'auto',
                },
                collapsed: {
                  opacity: 0,
                  height: 0,
                },
              }}
              transition={{
                delay: 0.1,
                duration: 0.3,
                easy: 'linear',
              }}
              className="flex overflow-hidden"
            >
              <Typography
                variant="textX"
                className={cn(
                  'dk:mt-[24px] tb:mt-[15px] mb:mt-[13px] text-gray-1 mb:max-tb:text-textS dk:max-w-[754px] tb:max-w-[558px]',
                  {
                    'dk:mb-0': option.image,
                  },
                  `${option.textSize}`,
                )}
              >
                {option.description}
              </Typography>
            </motion.div>
          </div>
          <div className="overflowX-hidden relative">
            <motion.div
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: {
                  opacity: 1,
                  height: 'auto',
                },
                collapsed: {
                  opacity: 0,
                  height: 0,
                },
              }}
              transition={{ delay: 0.1, duration: 0.3, easy: 'linear' }}
              className="flex overflow-hidden"
            >
              {option.image && (
                <div>
                  <Image
                    src={option.image.src}
                    alt="service-image"
                    style={
                      isDesktop
                        ? { height: option.image.heightDk }
                        : isLaptop
                          ? { height: option.image.heightTb }
                          : { height: option.image.heightMb }
                    }
                    width={
                      isDesktop
                        ? option.image.widthDk
                        : isLaptop
                          ? option.image.widthTb
                          : option.image.widthMb
                    }
                    height={
                      isDesktop
                        ? option.image.heightDk
                        : isLaptop
                          ? option.image.heightTb
                          : option.image.heightMb
                    }
                  />
                </div>
              )}
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default OtherBlocks;
